import { createContext } from "react";
import {
  PortalAuthenticationResult,
  PortalSettingsViewModel,
  RightsHolderInfoViewModel,
} from "../../../generated/data-contracts";
import { IPortalKind, ResCallback } from "../../../models";

type AvisContextType = {
  portalKind: IPortalKind;
  isAuthorized: boolean;
  isLoading: boolean;
  ctxRightsHolder?: RightsHolderInfoViewModel;
  ctxUser?: PortalAuthenticationResult;
  ctxRightsHolders?: RightsHolderInfoViewModel[];
  shouldSelectRightsHolder?: boolean;
  shouldSelectRightHolder?: boolean;
  ctxTextsToDisplay?: Record<string, string>;
  ctxPortalSettings?: PortalSettingsViewModel;
  setShouldSelectRightHolder: (value: boolean) => void;
  setShouldSelectRightsHolder: (value: boolean) => void;
  logout: () => void;
  login: (user?: PortalAuthenticationResult) => void;
  getText: (textKey: string) => string | JSX.Element[] | JSX.Element | null;
  res: ResCallback;
  resetRightsHolder: () => void;
  updateRightsHolder: (rightsHolder?: RightsHolderInfoViewModel) => void;
  updateUser: (user?: PortalAuthenticationResult) => void;
  setupAxiosInterceptors: () => void; // response interceptors
  setupErrorInterceptors: () => void; // error interceptors
};

export const AvisContext = createContext<AvisContextType>({
  portalKind: {
    portalType: undefined,
    requirePerimissions: undefined,
  },
  isAuthorized: false,
  isLoading: true,
  ctxRightsHolder: undefined,
  ctxUser: undefined,
  ctxTextsToDisplay: undefined,
  ctxRightsHolders: undefined,
  shouldSelectRightsHolder: false,
  ctxPortalSettings: undefined,
  setupAxiosInterceptors: () => {
    /** avoid eslint warning */
  },
  setShouldSelectRightHolder: () => {
    /** avoid eslint warning */
  },
  resetRightsHolder: () => {
    /** avoid eslint warning */
  },
  updateRightsHolder: () => {
    /** avoid eslint warning */
  },
  updateUser: () => {
    /** avoid eslint warning */
  },
  logout: () => {
    /** avoid eslint warning */
  },
  login: () => {
    /** avoid eslint warning */
  },
  getText: (textKey: string): string | JSX.Element[] | JSX.Element | null => {
    /** avoid eslint warning */
    return textKey;
  },
  res: (): string => {
    /** avoid eslint warning */
    return "";
  },
  setShouldSelectRightsHolder: () => {
    /** avoid eslint warning */
  },
  setupErrorInterceptors: () => {
    /** avoid eslint warning */
  },
});
